"use client";

/** Google IMA HTML5 SDK, loaded once from imasdk.googleapis.com (in-stream and outstream players). */

declare global {
  interface Window {
    google?: { ima?: any };
  }
}

const IMA_SRC = "https://imasdk.googleapis.com/js/sdkloader/ima3.js";
let imaLoading: Promise<boolean> | null = null;
let configured = false;

export function loadIma(locale = "zh_tw"): Promise<boolean> {
  if (typeof window === "undefined") return Promise.resolve(false);
  const ready = () => {
    const ima = window.google?.ima;
    if (ima && !configured) {
      configured = true;
      // SDK-global, must precede the first AdsLoader: the legacy player's language, and inline
      // (not full-screen) playback on iOS so a muted outstream can autoplay in the article.
      try { ima.settings.setLocale(locale); } catch { /* older SDK builds */ }
      try { ima.settings.setDisableCustomPlaybackForIOS10Plus(true); } catch { /* ignore */ }
    }
    return Boolean(ima);
  };
  if (window.google?.ima) return Promise.resolve(ready());
  if (!imaLoading) {
    imaLoading = new Promise((resolve) => {
      const s = document.createElement("script");
      s.src = IMA_SRC;
      s.async = true;
      s.onload = () => resolve(ready());
      s.onerror = () => resolve(false);
      document.head.appendChild(s);
    });
  }
  return imaLoading;
}
